import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../lib/api';
import { formatUsd, formatDate } from '../lib/format';

interface Customer {
  uuid: string;
  email: string;
  first_name: string | null;
  last_name: string | null;
  total_spent: number;
  order_count: number;
  last_seen_at: string;
}

export function CustomersList() {
  const [customers, setCustomers] = useState<Customer[]>([]);
  const [query, setQuery] = useState('');

  useEffect(() => {
    const params = new URLSearchParams();
    if (query) params.set('q', query);
    params.set('limit', '100');
    api
      .get<{ customers: Customer[] }>(`/api/admin/customers?${params}`)
      .then((d) => setCustomers(d.customers))
      .catch(console.error);
  }, [query]);

  return (
    <div>
      <h1 style={{ fontFamily: 'Georgia, serif', fontSize: 28, fontWeight: 400 }}>Customers</h1>
      <input
        placeholder="Search email, name, Stripe ID"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        style={{
          padding: '8px 12px',
          border: '1px solid #e5e5e5',
          borderRadius: 6,
          fontSize: 14,
          width: '100%',
          maxWidth: 400,
          margin: '16px 0 24px',
        }}
      />

      <div style={{ background: '#fff', border: '1px solid #e5e5e5', borderRadius: 8, overflow: 'hidden' }}>
        <div style={{ ...rowStyle, fontSize: 12, color: '#6b7280', textTransform: 'uppercase', letterSpacing: 1 }}>
          <span>Email</span>
          <span>Name</span>
          <span>Orders</span>
          <span>Lifetime</span>
          <span>Last seen</span>
        </div>
        {customers.length === 0 && (
          <p style={{ padding: 24, color: '#6b7280', margin: 0 }}>No customers yet.</p>
        )}
        {customers.map((c) => (
          <Link key={c.uuid} to={`/customers/${c.uuid}`} style={rowStyle}>
            <span style={{ fontSize: 14 }}>{c.email}</span>
            <span style={{ fontSize: 14 }}>
              {[c.first_name, c.last_name].filter(Boolean).join(' ') || '—'}
            </span>
            <span style={{ fontSize: 14, textAlign: 'center' }}>{c.order_count}</span>
            <span style={{ fontSize: 14, textAlign: 'right' }}>{formatUsd(c.total_spent)}</span>
            <span style={{ fontSize: 13, color: '#6b7280' }}>{formatDate(c.last_seen_at)}</span>
          </Link>
        ))}
      </div>
    </div>
  );
}

const rowStyle: React.CSSProperties = {
  display: 'grid',
  gridTemplateColumns: '1fr 1fr 80px 110px 160px',
  gap: 16,
  padding: '14px 20px',
  borderBottom: '1px solid #f0f0f0',
  alignItems: 'center',
  textDecoration: 'none',
  color: 'inherit',
};
